import React from 'react'
import styled from 'styled-components'

export const CardsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin-left: -10px;
	margin-right: -10px;
`

export const CardCol = styled.div`
	width: 265px;
	margin-bottom: 20px;
	padding-left: 10px;
	padding-right: 10px;
`
export const ModalInner = styled.div`
	max-height: 600px;
	overflow: hidden auto;
	margin-bottom: 20px;
`
